module.exports = __webpack_public_path__ + "img/cart_active.3f0a2016.svg";